module.exports = __webpack_public_path__ + "static/media/apple_pay.fe4f01ad.svg";